import { countries, ICountry, TCountryCode } from 'countries-list';

export function getCountries(): { code: string; country: ICountry }[] {
  const koncheni: TCountryCode[] = [
    'AF',
    'BY',
    'CD',
    'CF',
    'CN',
    'CU',
    'CY',
    'ER',
    'ET',
    'HT',
    'IQ',
    'IR',
    'KH',
    'KP',
    'LB',
    'LY',
    'MM',
    'RU',
    'SD',
    'SO',
    'SS',
    'SY',
    'VE',
    'ZW',
  ];
  const filtered = Object.entries(countries).filter(([countryCode]) => !koncheni.includes(countryCode as TCountryCode));
  return filtered.map((item) => ({
    code: item[0],
    country: item[1],
  }));
}
